<template>
	<div class="component">
		<div v-html="data"></div>
	</div>
</template>

<script>
export default {
	name: "Html",
	props : ['data']
}
</script>

<style scoped>

</style>